var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagenotfound"},[_c('div',{staticClass:"container-404"},[_c('img',{attrs:{"src":"/img/oops.png","alt":""}}),_c('p',[_vm._v("Oops il semblerait que cette page n'existe pas.")]),_c('router-link',{staticClass:"blue",attrs:{"to":"/"}},[_vm._v("Retour")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }